import { Product } from '@airship-platform/airship-proposal';
import { FlexBox } from '@airship-platform/jam-web/components';
import Button from '@mui/material/Button';
import { Link } from 'react-router';
import { useAppointmentProposalOptions } from '../../../data-access/appointmentProposalOptions';
import AddSubItemButton from './AddSubItemButton';
import QuickAddEquipmentButton from './QuickAddEquipmentButton';
import ReplaceItemButton from './ReplaceItemButton';

interface EquipmentListActionButtonsProps {
  product: Product;
  replaceProductId?: string | null;
  itemGroupRootId?: string | null;
}

const EquipmentListActionButtons: React.FC<EquipmentListActionButtonsProps> = ({
  product,
  replaceProductId,
  itemGroupRootId,
}) => {
  const { currentOption } = useAppointmentProposalOptions();

  const isReadOnly = currentOption?.isReadOnly ?? false;

  if (replaceProductId) {
    return (
      <FlexBox gap={1.5}>
        <ReplaceItemButton
          product={product}
          replaceProductId={replaceProductId}
        />
      </FlexBox>
    );
  }

  if (itemGroupRootId) {
    return (
      <FlexBox gap={1.5}>
        <AddSubItemButton product={product} itemGroupRootId={itemGroupRootId} />
      </FlexBox>
    );
  }

  return (
    <FlexBox gap={1.5}>
      <Button
        component={Link}
        to={product.pricebookId}
        color="softGold"
        disabled={isReadOnly}
        sx={{
          width: ['100%', 'auto'],
          textTransform: 'none',
          ...(isReadOnly && { pointerEvents: 'none' }),
        }}
      >
        Add item
      </Button>

      <QuickAddEquipmentButton product={product} />
    </FlexBox>
  );
};

export default EquipmentListActionButtons;
